import { Link } from "react-router-dom";
import { PageHero } from "@/components/site/PageParts";
import { Reveal } from "@/lib/motion";
import { ArrowRight } from "@phosphor-icons/react";

const STEPS = [
  { n: "01", t: "Confirm you're 18+", d: "Every visitor confirms adult age before entering. Doublelist is strictly for people 18 and over — no exceptions." },
  { n: "02", t: "Create a discreet profile", d: "Share only what you're comfortable with. You control your presence and can stay as private as you like." },
  { n: "03", t: "Browse & post honestly", d: "Explore personal classifieds and posts from other adults. Be clear about your intentions and respect others'." },
  { n: "04", t: "Connect with consent", d: "Reach out respectfully. Every connection is built on mutual, enthusiastic agreement — never pressure." },
  { n: "05", t: "Stay safe & report", d: "Use our safety guidelines, meet smart, and report anything that breaks the rules. We act on reports quickly." },
];

export default function HowItWorks() {
  return (
    <div data-testid="how-it-works-page">
      <PageHero
        index="B/"
        overline="How It Works"
        titleLines={["Simple, safe,", <>and <span className="italic text-oxblood">discreet</span></>]}
        intro="Five steps from arriving to connecting — with consent and privacy at every stage."
      />

      <section className="mx-auto max-w-[1400px] px-6 md:px-12 py-20 md:py-28">
        <div className="space-y-0">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.05}>
              <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-10 border-t border-line last:border-b group">
                <div className="md:col-span-2">
                  <span className="font-serif text-6xl md:text-7xl text-oxblood leading-none">{s.n}</span>
                </div>
                <div className="md:col-span-4">
                  <h3 className="font-serif text-3xl sm:text-4xl tracking-tight">{s.t}</h3>
                </div>
                <div className="md:col-span-6 flex items-center">
                  <p className="text-ink-soft leading-relaxed text-lg">{s.d}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="mt-16">
            <Link
              to="/safety"
              data-testid="how-safety-link"
              className="group inline-flex items-center gap-3 text-sm uppercase tracking-wider font-semibold border-b border-ink pb-1 hover:border-oxblood hover:text-oxblood transition-colors"
            >
              Review safety guidelines before you start
              <ArrowRight size={16} className="transition-transform duration-500 group-hover:translate-x-1" />
            </Link>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
